export const actions = {
  async registerAccount({ state, commit }, { userName, email, password, legalInn }) {
    let status = 0;
    try {
      let response = await coreAPIClient.post("/api/v1/registerAccount", { userName, email, password, legalInn });
      status = response.status;
    } catch (err) {
      if (err.response.status === 403) {
        state.invalidAttributes.userName = userName;
        state.invalidAttributes.email = email;
      }
      status = err.response.status;
    }
    return { status };
  },

  async login({ state, commit }, { userName, password }) {
    let status = 0;
    try {
      let response = await coreAPIClient.post("/api/v1/login", { userName, password });
      status = response.status;
    } catch (err) {
      status = err.response.status;
    }
    return { status };
  },

  async genResponseCode({ state }) {
    const response = await coreAPIClient.post("/api/v1/genResponseCode")
    state.responseCode = response.data.responseCode || ''
  },

  async logout() {
    try {
      await coreAPIClient.get("/api/v1/logout");
    } catch (err) {}
  },

  async sendEmailValidationMessage({ state, commit }, { userName, email }) {
    try {
      await coreAPIClient.post("/api/v1/sendEmailValidationMessage", { email: email });
      return true;
    } catch (err) {
      return false;
    }
  },

  async confirmEmailValidationEvent({ state, commit }, { uid }) {
    try {
      await coreAPIClient.post("/api/v1/confirmEmailValidationEvent", { uid: uid });
      return true;
    } catch (err) {
      return false;
    }
  },

  async sendForgotPasswordMessage({ state, commit }, { email }) {
    try {
      await coreAPIClient.post("/api/v1/sendForgotPasswordMessage", { email: email });
      return true;
    } catch (err) {
      return false;
    }
  },

  async changePassword({ state, commit }, { eventUid, newPassword }) {
    try {
      await coreAPIClient.post("/api/v1/changePassword", { eventUid, newPassword });
      return true;
    } catch (err) {
      return false;
    }
  },

  async meAccount({ state }) {
    try {
      let response = await coreAPIClient.get("/api/v1/meAccount");
      if (response.data.accountValid) {
        state.account = response.data.account;
        state.sid = response.data.sid;
      } else {
        state.account = null;
        state.sid = null;
      }
      return true;
    } catch (err) {
      return false;
    }
  }
};



// WEBPACK FOOTER //
// ./webapp/store/actions.js